// @ts-nocheck
import axios from 'axios';
import { BASE_URL } from '../../../../queries/useDataEngine';

export const ThemeAppearanceService = {
  getTheme: (params, loader = true) =>
    axios.get(BASE_URL + '/theme-customization', { params, loader }),
  updateTheme: (payload) =>
    axios.put(BASE_URL + '/theme-customization', payload),
  saveUserThemeType: (payload) =>
    axios.post(BASE_URL + '/userThemeSettings', payload),
};
